import styled from 'styled-components';
var Footer = styled.footer.withConfig({
  displayName: "Footerstyles__Footer",
  componentId: "sc-lddtmt-0"
})(["width:100%;height:92px;background:var(--dentsu-color-n50);padding:var(--dentsu-spacing-24) var(--dentsu-spacing-32);"]);
var FooterActions = styled.div.withConfig({
  displayName: "Footerstyles__FooterActions",
  componentId: "sc-lddtmt-1"
})(["display:flex;align-items:center;justify-content:flex-end;button{margin-left:var(--dentsu-spacing-8);}"]);
export var Styled = {
  Footer: Footer,
  FooterActions: FooterActions
};